/**
 *
 * @desc DisplayAds utility
 *
 */
class DisplayAds {
    static init(displayAdConfig, skipContainers) {
        if (!this.canDisplayAds(displayAdConfig)) {
            return false;
        }
        const { pageTargeting, adUnitHierarchy1, adUnitHierarchy2, responsive } = displayAdConfig;
        window.milbDoubleclick.setPageTargeting(pageTargeting);
        window.milbDoubleclick.init({
            adUnitHierarchy1,
            adUnitHierarchy2,
            responsive,
            skipContainers
        });

        return true;
    }

    static canDisplayAds(displayAdConfig) {
        if (typeof displayAdConfig === 'undefined') {
            return false;
        }
        const { enabled, adUnitHierarchy1, adUnitHierarchy2 } = displayAdConfig;

        return (
            enabled &&
            adUnitHierarchy1 &&
            adUnitHierarchy2 &&
            typeof window !== 'undefined' &&
            typeof window.milbDoubleclick !== 'undefined'
        );
    }

    static setPageTargeting(displayAdConfig) {
        const { pageTargeting } = displayAdConfig;
        if (!this.canDisplayAds(displayAdConfig) || typeof pageTargeting !== 'undefined') {
            return false;
        }

        window.milbDoubleclick.setPageTargeting(pageTargeting);

        return true;
    }

    static refreshSlots(displayAdConfig) {
        if (!this.canDisplayAds(displayAdConfig)) {
            return false;
        }

        let adSlotIdsToRefresh = [];

        const { displayAds = [] } = displayAdConfig;

        displayAds.forEach((displayAd) => {
            const adSlots = displayAd['ad-sizes'];

            adSlots.forEach((adSlot) => {
                const adSlotContentId = adSlot.contentId;

                adSlotIdsToRefresh.push(`ad-${adSlotContentId}`);
            });
        });

        if (adSlotIdsToRefresh.length > 0) {
            window.milbDoubleclick.refresh(adSlotIdsToRefresh);
        }

        return true;
    }

    static destroySlots(displayAdConfig) {
        if (!this.canDisplayAds(displayAdConfig)) {
            return false;
        }

        let adSlotIdsToDestroy = [];

        const { displayAds = [] } = displayAdConfig;

        displayAds.forEach((displayAd) => {
            const adSlots = displayAd['ad-sizes'];

            adSlots.forEach((adSlot) => {
                const adSlotContentId = adSlot.contentId;

                adSlotIdsToDestroy.push(`ad-${adSlotContentId}`);
            });
        });

        if (adSlotIdsToDestroy.length > 0) {
            window.milbDoubleclick.destroySlots(adSlotIdsToDestroy);
        }

        return true;
    }
}

export default DisplayAds;
